import { render } from "./DatasetCleanerTooltip.vue?vue&type=template&id=fb5c66a4"
import script from "./DatasetCleanerTooltip.vue?vue&type=script&lang=js"
export * from "./DatasetCleanerTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__